import { ApiResponse, axiosInstance, AxiosErrorCustom } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { ILabelCustomer } from '@/features/settings/label/label-customer/types/label-customer.type';

export const UnassignCasesInputSchema = z.object({
  caseIds: z
    .array(z.string({ required_error: 'Conversation ID is required!' }).min(1))
    .min(1, { message: 'At least one conversation ID is required!' }),
});
export type TUnassignCasesInput = z.infer<typeof UnassignCasesInputSchema>;
export type TUnassignCasesResponse = ApiResponse<ILabelCustomer>;

export const unassignCases = async (data: TUnassignCasesInput): Promise<TUnassignCasesResponse> => {
  const url = `/chat/unassigned-conversation`;

  return axiosInstance.post(url, data);
};

type UseUnassignCasesOptions = {
  mutationConfig?: TypedMutationConfig<typeof unassignCases, AxiosErrorCustom>;
};

export const useUnassignCases = ({ mutationConfig }: UseUnassignCasesOptions) => {
  const { onError, ...rest } = mutationConfig || {};

  return useMutation<TUnassignCasesResponse, AxiosErrorCustom, TUnassignCasesInput>({
    ...rest,
    mutationFn: unassignCases,
    onError,
  });
};
